"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const range = (from, to) => (new Array(to - from)
    .fill(null)
    .map((_, index) => from + index));
exports.default = range;
